var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lobby"},[(!_vm.condition)?[_c('div',{staticClass:"bghome"}),_c('FModal')]:[_c('Header',{attrs:{"id":"Header"}}),_c('HomeLobby',{attrs:{"id":"HomeLobby"}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }